// src/data/eventsData.js

// Import event images
import SkillDevepImage from '../assets/skill_development.jpg';
import SkillDevepImage2 from '../assets/skill_development2_certificate.jpg';
import AgricultureFestival1 from '../assets/Globalkm251.jpg';
import ShreeGhorKashtodwarakPujan from '../assets/ghorKashtodharakBanner.jpg';
import Mauli from '../assets/Gurumauli.jpg';
import gangapurEvent from '../assets/Gangapur_event.jpg';
import Swayamrojgar from '../assets/vibhag-logos/swayam-rojgar.png';
import AgricultureFestival from "../assets/Globalkm25.jpg";
import JKMKrushi from "../assets/JKM26.jpg";
export const eventsData = {
  mr: [
     {
    id: 1,
    title: "श्री घोर कष्टोद्वारक पूजन",
    subtitle: "विशेष पूजन कार्यक्रम",
    date: "२४ - २६ ऑक्टोबर २०२५",
    thumbnail: ShreeGhorKashtodwarakPujan,
    photos: [ShreeGhorKashtodwarakPujan, gangapurEvent],
    videos: [
      {
        title: "घोर कष्टोद्वारक पूजन",
        url: "https://www.youtube.com/embed/EH8bHnCeXnM?si=NdfXGm2VN15R46jn"
      }
    ],
    description: "श्री घोर कष्टोद्वारक पूजन हे मानसिक, शारीरिक व आर्थिक संकटांपासून मुक्ती देणारे अत्यंत प्रभावी पूजन आहे. या पूजनाद्वारे श्रद्धाळूंना परमेश्वर कृपा प्राप्त होते.",
    fullContent: `
      <h3>🙏 श्री घोर कष्टोद्वारक पूजन</h3>
      <p>हे पूजन जीवनातील गंभीर समस्यांवर, मानसिक-शारीरिक कष्टांवर आणि आर्थिक अडचणींवर उपाय म्हणून करण्यात येते.</p>

      <h4>✨ पूजनाचे लाभ:</h4>
      <ul>
        <li>शारीरिक व मानसिक कष्टांचे निवारण</li>
        <li>गंभीर आर्थिक व कौटुंबिक समस्यांपासून मुक्ती</li>
        <li>व्यवसाय, नोकरी व आरोग्यासाठी विशेष फलदायी</li>
      </ul>

      <h4>📅 तारीख:</h4>
      <p>२४ ते २६ ऑक्टोबर २०२५</p>

      <h4>📍 स्थळ:</h4>
      <p><strong>अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ शाखा</strong><br>गणगापुर (कर्नाटक)</p>

      <h4>📞 संपर्क:</h4>
      <p>8956630913 / 8956630914 / 8956630915 / 7709107339 / 9970447132</p>
    `,
    venue: {
      name: "अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ शाखा",
      address: "गणगापुर, कर्नाटक",
      mapLink: "https://maps.app.goo.gl/yrvTaTonq7BCPkrs6"
    },
    highlights: [
      "शारीरिक, मानसिक व आर्थिक कष्टांपासून मुक्ती",
      "गंभीर समस्यांचे समाधान",
      "गुरुप्रसाद व आशीर्वाद लाभ"
    ],
    timings: "२४ ते २६ ऑक्टोबर २०२५",
    location: "गणगापुर, कर्नाटक"
  },
    {
      id: 2,
      title: "जागतिक कृषी महोत्सव 2026",
      subtitle: "सेंद्रिय व नैसर्गिक शेतीचा उत्सव",
      date: "जानेवारी 23-27, 2026",
      thumbnail: JKMKrushi,
      photos: [JKMKrushi, AgricultureFestival, AgricultureFestival1],
      videos: [
        {
          title: "कृषी महोत्सव 2024 हायलाइट्स",
          url: "https://www.youtube.com/embed/dohcsIlAbrk"
        },
        {
          title: "सेंद्रिय शेती तंत्रे",
          url: "https://www.youtube.com/embed/_Y7Icpgqcbc"
        }
      ],
      description: "कृषी महोत्सव हा श्री स्वामी समर्थ सेवा मार्ग, दिंडोरी अंतर्गत नाशिक येथे आयोजित केलेला आंतरराष्ट्रीय कृषी उत्सव आहे. हा महोत्सव सेंद्रिय शेती, शाश्वत शेती आणि पारंपारिक शेती पद्धतींना प्रोत्साहन देतो.",
      fullContent: `
        <h3>🌾 जागतिक कृषी महोत्सव 2026</h3>
        <p>कृषी महोत्सव हा श्री स्वामी समर्थ सेवा मार्ग, दिंडोरी अंतर्गत नाशिक येथे आयोजित केलेला आंतरराष्ट्रीय कृषी उत्सव आहे.</p>
        
        <h4>✨ मुख्य आकर्षणे:</h4>
        <ul>
          <li>आंतरराष्ट्रीय शेतकरी प्रदर्शन</li>
          <li>सेंद्रिय शेती कार्यशाळा आणि प्रात्यक्षिके</li>
          <li>कृषी उपकरणे प्रदर्शन</li>
          <li>पारंपारिक बियाणे संरक्षण केंद्र</li>
          <li>पशुधन आणि दुग्धव्यवसाय मार्गदर्शन</li>
          <li>मोफत माती परीक्षण शिबीर</li>
          <li>प्रगतीशील शेतकऱ्यांसाठी पुरस्कार</li>
        </ul>

        <h4>📍 स्थळ:</h4>
        <p><strong>कृषी प्रदर्शन मैदान, नाशिक</strong><br>
        कृषी महोत्सव मैदान, दिंडोरी रोड, नाशिक, महाराष्ट्र 422202</p>

        <h4>🕐 वेळ:</h4>
        <p>सकाळी 8:00 - रात्री 8:00 (सर्व 5 दिवस)</p>

        <h4>🌐 अधिक माहितीसाठी:</h4>
        <p><a href="https://www.krushimahotsav.org/" target="_blank">www.krushimahotsav.org</a></p>
      `,
      venue: {
        name: "कृषी प्रदर्शन मैदान, नाशिक",
        address: "कृषी महोत्सव मैदान, दिंडोरी रोड, नाशिक, महाराष्ट्र 422202",
        mapLink: "https://www.krushimahotsav.org/"
      },
      highlights: [
        "आंतरराष्ट्रीय शेतकरी प्रदर्शन",
        "सेंद्रिय शेती कार्यशाळा आणि प्रात्यक्षिके",
        "कृषी उपकरणे प्रदर्शन",
        "पारंपारिक बियाणे संरक्षण केंद्र",
        "पशुधन आणि दुग्धव्यवसाय मार्गदर्शन",
        "मोफत माती परीक्षण शिबीर",
        "प्रगतीशील शेतकऱ्यांसाठी पुरस्कार"
      ],
      timings: "सकाळी 8:00 - रात्री 8:00 (सर्व 5 दिवस)",
      location: "नाशिक, महाराष्ट्र"
    },
    {
      id: 3,
      title: "कौशल्य प्रशिक्षण उपक्रम",
      subtitle: "स्वयंरोजगार आणि व्यावसायिक कार्यशाळा",
      date: "नोव्हेंबर 02, 2025",
      thumbnail: Swayamrojgar,
      photos: [Swayamrojgar, SkillDevepImage2, SkillDevepImage],
      videos: [
        {
          title: "यशोगाथा",
          url: "https://www.youtube.com/embed/6JSiEUtimkk?si=wpGVoG8ydYtW1CUS"
        }
      ],
      description: "युवक आणि महिलांना व्यावसायिक प्रशिक्षण, उद्योजकता मार्गदर्शन आणि स्वयंरोजगार संधींसह सक्षम करण्याचा एक व्यापक कौशल्य विकास कार्यक्रम.",
      fullContent: `
        <h3>💼 कौशल्य प्रशिक्षण उपक्रम</h3>
        <p>युवक आणि महिलांना व्यावसायिक प्रशिक्षण, उद्योजकता मार्गदर्शन आणि स्वयंरोजगार संधींसह सक्षम करण्याचा एक व्यापक कौशल्य विकास कार्यक्रम.</p>
        
        <h4>✨ मुख्य आकर्षणे:</h4>
        <ul>
          <li>शिवणकाम आणि वस्त्र निर्मिती</li>
          <li>संगणक प्रशिक्षण आणि डिजिटल साक्षरता</li>
          <li>अन्न प्रक्रिया आणि पॅकेजिंग</li>
          <li>सौंदर्य आणि निरोगीपणा अभ्यासक्रम</li>
          <li>लघु व्यवसाय व्यवस्थापन</li>
          <li>पूर्णत्वावर मोफत प्रमाणपत्र</li>
          <li>नोकरी मिळविण्यात मदत</li>
        </ul>

        <h4>📍 स्थळ:</h4>
        <p><strong>सेवा मार्ग प्रशिक्षण केंद्र, दिंडोरी</strong><br>
        श्री गुरुपीठ परिसर, दिंडोरी, नाशिक, महाराष्ट्र 422202</p>

        <h4>🕐 वेळ:</h4>
        <p>सकाळी 9:00 - संध्याकाळी 5:00 (6 दिवसीय कार्यक्रम)</p>
      `,
      venue: {
        name: "सेवा मार्ग प्रशिक्षण केंद्र, दिंडोरी",
        address: "श्री गुरुपीठ परिसर, दिंडोरी, नाशिक, महाराष्ट्र 422202",
        mapLink: "https://maps.google.com/?q=Dindori+Nashik"
      },
      highlights: [
        "शिवणकाम आणि वस्त्र निर्मिती",
        "संगणक प्रशिक्षण आणि डिजिटल साक्षरता",
        "अन्न प्रक्रिया आणि पॅकेजिंग",
        "सौंदर्य आणि निरोगीपणा अभ्यासक्रम",
        "लघु व्यवसाय व्यवस्थापन",
        "पूर्णत्वावर मोफत प्रमाणपत्र",
        "नोकरी मिळविण्यात मदत"
      ],
      timings: "सकाळी 9:00 - संध्याकाळी 5:00 (6 दिवसीय कार्यक्रम)",
      location: "दिंडोरी, नाशिक"
    }
  ],
 en: [
  {
    id: 1,
    title: "Shree Ghor Kashtodwarak Pujan",
    subtitle: "Special Spiritual Ceremony",
    date: "October 24–26, 2025",
    thumbnail: ShreeGhorKashtodwarakPujan,
    photos: [ShreeGhorKashtodwarakPujan, gangapurEvent],
    videos: [
      {
        title: "Ghor Kashtodwarak Pujan",
        url: "https://www.youtube.com/embed/EH8bHnCeXnM?si=NdfXGm2VN15R46jn"
      }
    ],
    description: "The Shree Ghor Kashtodwarak Pujan is a powerful ritual that helps devotees overcome mental, physical, and financial difficulties through divine grace.",
    fullContent: `
      <h3>🙏 Shree Ghor Kashtodwarak Pujan</h3>
      <p>This special pujan is performed to remove severe life obstacles, relieve stress and suffering, and attract divine blessings for overall well-being.</p>

      <h4>✨ Benefits:</h4>
      <ul>
        <li>Relief from physical and mental distress</li>
        <li>Freedom from financial and family problems</li>
        <li>Success and peace in business, job, and health matters</li>
      </ul>

      <h4>📅 Dates:</h4>
      <p>October 24–26, 2025</p>

      <h4>📍 Venue:</h4>
      <p><strong>Akhil Bharatiya Shree Swami Samarth Gurupeeth Branch</strong><br>Ganagapur, Karnataka</p>

      <h4>📞 Contact:</h4>
      <p>8956630913 / 8956630914 / 8956630915 / 7709107339 / 9970447132</p>
    `,
    venue: {
      name: "Akhil Bharatiya Shree Swami Samarth Gurupeeth Branch",
      address: "Ganagapur, Karnataka",
      mapLink: "https://maps.app.goo.gl/yrvTaTonq7BCPkrs6"
    },
    highlights: [
      "Freedom from mental, physical, and financial suffering",
      "Solutions for major life problems",
      "Divine blessings from Gurupeeth"
    ],
    timings: "October 24–26, 2025",
    location: "Ganagapur, Karnataka"
  },
    {
      id: 2,
      title: "Global Agricultural Festival 2026",
      subtitle: "Celebrating Organic & Natural Farming",
      date: "January 23-27, 2026",
      thumbnail: JKMKrushi,
      photos: [JKMKrushi, AgricultureFestival, AgricultureFestival1],
      videos: [
        {
          title: "Krushi Mahotsav 2024 Highlights",
          url: "https://www.youtube.com/embed/dohcsIlAbrk"
        },
        {
          title: "Organic Farming Techniques",
          url: "https://www.youtube.com/embed/_Y7Icpgqcbc"
        }
      ],
      description: "Krushi Mahotsav is an international agricultural festival organized in Nashik under the Shri Swami Samarth Seva Marg, Dindori. This festival promotes organic farming, sustainable agriculture, and traditional farming methods.",
      fullContent: `
        <h3>🌾 Global Agricultural Festival 2026</h3>
        <p>Krushi Mahotsav is an international agricultural festival organized in Nashik under the Shri Swami Samarth Seva Marg, Dindori.</p>
        
        <h4>✨ Highlights:</h4>
        <ul>
          <li>International farmers' exhibition</li>
          <li>Organic farming workshops and demonstrations</li>
          <li>Agricultural equipment showcase</li>
          <li>Traditional seed preservation center</li>
          <li>Livestock and dairy farming guidance</li>
          <li>Free soil testing camp</li>
          <li>Awards for progressive farmers</li>
        </ul>

        <h4>📍 Venue:</h4>
        <p><strong>Agriculture Exhibition Ground, Nashik</strong><br>
        Krushi Mahotsav Grounds, Dindori Road, Nashik, Maharashtra 422202</p>

        <h4>🕐 Timings:</h4>
        <p>8:00 AM - 8:00 PM (All 5 days)</p>

        <h4>🌐 More Information:</h4>
        <p><a href="https://www.krushimahotsav.org/" target="_blank">www.krushimahotsav.org</a></p>
      `,
      venue: {
        name: "Agriculture Exhibition Ground, Nashik",
        address: "Krushi Mahotsav Grounds, Dindori Road, Nashik, Maharashtra 422202",
        mapLink: "https://www.krushimahotsav.org/"
      },
      highlights: [
        "International farmers' exhibition",
        "Organic farming workshops and demonstrations",
        "Agricultural equipment showcase",
        "Traditional seed preservation center",
        "Livestock and dairy farming guidance",
        "Free soil testing camp",
        "Awards for progressive farmers"
      ],
      timings: "8:00 AM - 8:00 PM (All 5 days)",
      location: "Nashik, Maharashtra"
    },
    {
      id: 3,
      title: "Skill Training Drive",
      subtitle: "Self-employment & Vocational Workshops",
      date: "November 02, 2025",
      thumbnail: Swayamrojgar,
      photos: [Swayamrojgar, SkillDevepImage2, SkillDevepImage],
      videos: [
        {
          title: "Success Stories",
          url: "https://www.youtube.com/embed/6JSiEUtimkk?si=wpGVoG8ydYtW1CUS"
        }
      ],
      description: "A comprehensive skill development program aimed at empowering youth and women with vocational training, entrepreneurship guidance, and self-employment opportunities.",
      fullContent: `
        <h3>💼 Skill Training Drive</h3>
        <p>A comprehensive skill development program aimed at empowering youth and women with vocational training, entrepreneurship guidance, and self-employment opportunities.</p>
        
        <h4>✨ Highlights:</h4>
        <ul>
          <li>Tailoring and garment making</li>
          <li>Computer training and digital literacy</li>
          <li>Food processing and packaging</li>
          <li>Beauty and wellness courses</li>
          <li>Small business management</li>
          <li>Free certification on completion</li>
          <li>Placement assistance</li>
        </ul>

        <h4>📍 Venue:</h4>
        <p><strong>Seva Marg Training Center, Dindori</strong><br>
        Shree Gurupeeth Campus, Dindori, Nashik, Maharashtra 422202</p>

        <h4>🕐 Timings:</h4>
        <p>9:00 AM - 5:00 PM (6 days program)</p>
      `,
      venue: {
        name: "Seva Marg Training Center, Dindori",
        address: "Shree Gurupeeth Campus, Dindori, Nashik, Maharashtra 422202",
        mapLink: "https://maps.google.com/?q=Dindori+Nashik"
      },
      highlights: [
        "Tailoring and garment making",
        "Computer training and digital literacy",
        "Food processing and packaging",
        "Beauty and wellness courses",
        "Small business management",
        "Free certification on completion",
        "Placement assistance"
      ],
      timings: "9:00 AM - 5:00 PM (6 days program)",
      location: "Dindori, Nashik"
    }
  ]
};